import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import CelebrationRoundedIcon from "@mui/icons-material/CelebrationRounded";
import KitchenRoundedIcon from "@mui/icons-material/KitchenRounded";
import LayersRoundedIcon from "@mui/icons-material/LayersRounded";
import PoolRoundedIcon from "@mui/icons-material/PoolRounded";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import SpeakerRoundedIcon from "@mui/icons-material/SpeakerRounded";
import SportsVolleyballRoundedIcon from "@mui/icons-material/SportsVolleyballRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgent";
import TvRoundedIcon from "@mui/icons-material/TvRounded";
import { Box, Chip, Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useState } from "react";
import imgAnniversaire from "../assets/images/VitalEau-Anniversaire-Piscine-1552.jpg";
import imgAnniversaireGroupe from "../assets/images/VitalEau-Anniversaire-Piscine.jpg";
import MetaMaster from "../components/utils/MetaMaster";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function Evenements() {
    const [arianeItem] = useState([
        ["/", "Vital'Eau"],
        ["/anniversaire", "Anniversaire"],
    ]);

    return (
        <div className="pageanniversaire">
            <MetaMaster title={"Vital'eau - Anniversaire"} />
            <HeroInner arianeItem={arianeItem} imagesSwiper={[imgAnniversaire]} />
            <section className="section-event-page" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner">
                                    Organisez un anniversaire <br /> inoubliable à la piscine <br /> Vital’Eau ! 🫧
                                </h1>
                                <p className="">
                                    Plongez dans un univers de fête et de détente. <br />
                                    Privatisation, jeux aquatiques et ambiance musicale pour <br />
                                    le plus beau jour de votre enfant.
                                </p>
                            </div>
                        </Grid>
                        <Grid item lg={5} md={5} sm={12} xs={12}>
                            <div style={{ position: "relative", paddingTop: "56.25%", marginTop: "52px" }}>
                                <iframe
                                    src="https://www.youtube.com/embed/iAjzfHxeiDM?si=IyjgP6G90MNeULj6"
                                    title="YouTube video player"
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        width: "100%",
                                        height: "100%",
                                        border: 0,
                                    }}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            <section>
                <section className="section-event-highlight">
                    <Container maxWidth="xl">
                        <Box className="event-highlight-wrapper">
                            <Grid
                                container
                                spacing={3}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Grid item xs={12} md={8}>
                                    <Box className="event-highlight-card event-highlight-card--content">
                                        <h2 className="event-highlight-title">Une expérience sur-mesure</h2>

                                        <p className="event-highlight-text">
                                            Vous cherchez une idée originale pour fêter un anniversaire ? Offrez une expérience unique à votre enfant
                                            et à ses amis en privatisant la piscine de <strong>Vital’Eau</strong> le dimanche après-midi. Jeux
                                            aquatiques, musique, rires et souvenirs mémorables sont au rendez-vous ! <br /> <br /> Notre équipe vous
                                            accueille dans un cadre sécurisé et convivial pour une fête dynamique et amusante, encadrée par le
                                            personnel de Vital’Eau. Les enfants profitent pleinement du bassin avec différents équipements mis à
                                            disposition pour jouer et s’amuser dans l’eau.
                                        </p>

                                        <Box className="event-highlight-tags">
                                            <Chip label="PRIVATISATION" size="small" />
                                            <Chip label="MUSIQUE" size="small" />
                                            <Chip label="JEUX" size="small" />
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={4} className="event-highlight-card">
                                    <Box>
                                        <div className="event-highlight-badge">🎂 À partir de 5 ans</div>
                                    </Box>
                                    <Box className="event-highlight-card event-highlight-card--stats">
                                        <svg width="33" height="28" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M7 10C8.06087 10 9.07828 9.57857 9.82843 8.82843C10.5786 8.07828 11 7.06087 11 6C11 4.93913 10.5786 3.92172 9.82843 3.17157C9.07828 2.42143 8.06087 2 7 2C5.93913 2 4.92172 2.42143 4.17157 3.17157C3.42143 3.92172 3 4.93913 3 6C3 7.06087 3.42143 8.07828 4.17157 8.82843C4.92172 9.57857 5.93913 10 7 10ZM7 12C7.78793 12 8.56815 11.8448 9.2961 11.5433C10.0241 11.2417 10.6855 10.7998 11.2426 10.2426C11.7998 9.68549 12.2417 9.02405 12.5433 8.2961C12.8448 7.56815 13 6.78793 13 6C13 5.21207 12.8448 4.43185 12.5433 3.7039C12.2417 2.97595 11.7998 2.31451 11.2426 1.75736C10.6855 1.20021 10.0241 0.758251 9.2961 0.456723C8.56815 0.155195 7.78793 -1.17411e-08 7 0C5.4087 2.37122e-08 3.88258 0.632141 2.75736 1.75736C1.63214 2.88258 1 4.4087 1 6C1 7.5913 1.63214 9.11742 2.75736 10.2426C3.88258 11.3679 5.4087 12 7 12Z"
                                                fill="#FFFFFF"
                                            />
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M4.708 9.79222C4.80113 9.88512 4.87501 9.99547 4.92543 10.117C4.97584 10.2384 5.00179 10.3687 5.00179 10.5002C5.00179 10.6318 4.97584 10.762 4.92543 10.8835C4.87501 11.005 4.80113 11.1153 4.708 11.2082L4.032 11.8822C2.73107 13.1835 2.00017 14.9482 2 16.7882V20.5002C2 20.7654 1.89464 21.0198 1.70711 21.2073C1.51957 21.3949 1.26522 21.5002 1 21.5002C0.734784 21.5002 0.48043 21.3949 0.292893 21.2073C0.105357 21.0198 0 20.7654 0 20.5002V16.7882C0.000283518 14.4178 0.941971 12.1445 2.618 10.4682L3.292 9.79222C3.38489 9.6991 3.49524 9.62521 3.61673 9.5748C3.73822 9.52439 3.86847 9.49844 4 9.49844C4.13153 9.49844 4.26178 9.52439 4.38327 9.5748C4.50476 9.62521 4.61511 9.6991 4.708 9.79222ZM28.292 9.19222C28.1989 9.28512 28.125 9.39547 28.0746 9.51696C28.0242 9.63845 27.9982 9.76869 27.9982 9.90022C27.9982 10.0318 28.0242 10.162 28.0746 10.2835C28.125 10.405 28.1989 10.5153 28.292 10.6082L28.968 11.2822C29.6122 11.9265 30.1233 12.6914 30.4719 13.5331C30.8206 14.3749 31 15.2771 31 16.1882V20.5002C31 20.7654 31.1054 21.0198 31.2929 21.2073C31.4804 21.3949 31.7348 21.5002 32 21.5002C32.2652 21.5002 32.5196 21.3949 32.7071 21.2073C32.8946 21.0198 33 20.7654 33 20.5002V16.1882C32.9997 13.8178 32.058 11.5445 30.382 9.86823L29.708 9.19222C29.6151 9.0991 29.5048 9.02521 29.3833 8.9748C29.2618 8.92439 29.1315 8.89844 29 8.89844C28.8685 8.89844 28.7382 8.92439 28.6167 8.9748C28.4952 9.02521 28.3849 9.0991 28.292 9.19222Z"
                                                fill="#FFFFFF"
                                            />
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M25 10C23.9391 10 22.9217 9.57857 22.1716 8.82843C21.4214 8.07828 21 7.06087 21 6C21 4.93913 21.4214 3.92172 22.1716 3.17157C22.9217 2.42143 23.9391 2 25 2C26.0609 2 27.0783 2.42143 27.8284 3.17157C28.5786 3.92172 29 4.93913 29 6C29 7.06087 28.5786 8.07828 27.8284 8.82843C27.0783 9.57857 26.0609 10 25 10ZM25 12C24.2121 12 23.4319 11.8448 22.7039 11.5433C21.9759 11.2417 21.3145 10.7998 20.7574 10.2426C20.2002 9.68549 19.7583 9.02405 19.4567 8.2961C19.1552 7.56815 19 6.78793 19 6C19 5.21207 19.1552 4.43185 19.4567 3.7039C19.7583 2.97595 20.2002 2.31451 20.7574 1.75736C21.3145 1.20021 21.9759 0.758251 22.7039 0.456723C23.4319 0.155195 24.2121 -1.17411e-08 25 0C26.5913 2.37122e-08 28.1174 0.632141 29.2426 1.75736C30.3679 2.88258 31 4.4087 31 6C31 7.5913 30.3679 9.11742 29.2426 10.2426C28.1174 11.3679 26.5913 12 25 12ZM16 18.5C14.6739 18.5 13.4021 19.0268 12.4645 19.9645C11.5268 20.9021 11 22.1739 11 23.5V26.1C11 26.3652 10.8946 26.6196 10.7071 26.8071C10.5196 26.9946 10.2652 27.1 10 27.1C9.73478 27.1 9.48043 26.9946 9.29289 26.8071C9.10536 26.6196 9 26.3652 9 26.1V23.5C9 21.6435 9.7375 19.863 11.0503 18.5503C12.363 17.2375 14.1435 16.5 16 16.5C17.8565 16.5 19.637 17.2375 20.9497 18.5503C22.2625 19.863 23 21.6435 23 23.5V26.1C23 26.3652 22.8946 26.6196 22.7071 26.8071C22.5196 26.9946 22.2652 27.1 22 27.1C21.7348 27.1 21.4804 26.9946 21.2929 26.8071C21.1054 26.6196 21 26.3652 21 26.1V23.5C21 22.8434 20.8707 22.1932 20.6194 21.5866C20.3681 20.98 19.9998 20.4288 19.5355 19.9645C19.0712 19.5002 18.52 19.1319 17.9134 18.8806C17.3068 18.6293 16.6566 18.5 16 18.5Z"
                                                fill="#FFFFFF"
                                            />
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M16 15.5C17.0609 15.5 18.0783 15.0786 18.8284 14.3284C19.5786 13.5783 20 12.5609 20 11.5C20 10.4391 19.5786 9.42172 18.8284 8.67157C18.0783 7.92143 17.0609 7.5 16 7.5C14.9391 7.5 13.9217 7.92143 13.1716 8.67157C12.4214 9.42172 12 10.4391 12 11.5C12 12.5609 12.4214 13.5783 13.1716 14.3284C13.9217 15.0786 14.9391 15.5 16 15.5ZM16 17.5C17.5913 17.5 19.1174 16.8679 20.2426 15.7426C21.3679 14.6174 22 13.0913 22 11.5C22 9.9087 21.3679 8.38258 20.2426 7.25736C19.1174 6.13214 17.5913 5.5 16 5.5C14.4087 5.5 12.8826 6.13214 11.7574 7.25736C10.6321 8.38258 10 9.9087 10 11.5C10 13.0913 10.6321 14.6174 11.7574 15.7426C12.8826 16.8679 14.4087 17.5 16 17.5Z"
                                                fill="#FFFFFF"
                                            />
                                        </svg>

                                        <p className="event-highlight-stats-number">30</p>
                                        <p className="event-highlight-stats-label">PARTICIPANTS MAXIMUM</p>
                                        <span>(adultes et enfants confondus)</span>
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <Box className="event-highlight-card event-highlight-card--services">
                                        <h2 className="event-highlight-services-title">Inclus dans toutes nos prestations</h2>
                                        <p className="baseline">Pour rendre la fête encore plus amusante</p>
                                        <Box className="event-highlight-services-grid">
                                            <Box className="event-service-item">
                                                <Box className="event-service-icon">
                                                    <SportsVolleyballRoundedIcon />
                                                </Box>
                                                <p className="event-service-label">BALLONS</p>
                                            </Box>

                                            <Box className="event-service-item">
                                                <Box className="event-service-icon">
                                                    <LayersRoundedIcon />
                                                </Box>
                                                <p className="event-service-label">TAPIS AQUATIQUES</p>
                                            </Box>

                                            <Box className="event-service-item">
                                                <Box className="event-service-icon">
                                                    <TvRoundedIcon />
                                                </Box>
                                                <p className="event-service-label">ÉCRAN GÉANT</p>
                                            </Box>

                                            <Box className="event-service-item">
                                                <Box className="event-service-icon">
                                                    <SpeakerRoundedIcon />
                                                </Box>
                                                <p className="event-service-label">SONO</p>
                                            </Box>

                                            <Box className="event-service-item">
                                                <Box className="event-service-icon">
                                                    <SupportAgentRoundedIcon />
                                                </Box>
                                                <p className="event-service-label">ENCADREMENT</p>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </section>
            </section>
            <section className="section-event-pricing">
                <Container maxWidth="xl">
                    <Box className="event-pricing">
                        <Box className="event-pricing-header">
                            <h2 className="event-pricing-title">Nos Formules Anniversaire</h2>
                            <p className="baseline">Choisissez la durée idéale pour une fête mémorable.</p>
                        </Box>

                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} md={6} lg={4}>
                                <Box className="pricing-card pricing-card--featured">
                                    <h3 className="pricing-card-title">L'Express</h3>

                                    <p className="pricing-card-price">175€</p>

                                    <Box className="pricing-card-features">
                                        <Box className="pricing-feature">
                                            <AccessTimeRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">1 heure dans l’eau</p>
                                        </Box>

                                        <Box className="pricing-feature">
                                            <PoolRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">Accès piscine</p>
                                        </Box>

                                        <Box className="pricing-feature">
                                            <CelebrationRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">Jeux, animation, musique &amp; matériel inclus</p>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} lg={4}>
                                <Box className="pricing-card pricing-card--featured">
                                    <h3 className="pricing-card-title">Le Grand Plongeon</h3>

                                    <p className="pricing-card-price">215€</p>

                                    <Box className="pricing-card-features">
                                        <Box className="pricing-feature">
                                            <AccessTimeRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text pricing-feature-text--strong">1 heure 30 dans l’eau</p>
                                        </Box>

                                        <Box className="pricing-feature">
                                            <PoolRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">Accès piscine</p>
                                        </Box>

                                        <Box className="pricing-feature">
                                            <CelebrationRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">Jeux, animation, musique &amp; matériel inclus</p>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} lg={4}>
                                <Box className="pricing-card pricing-card--featured">
                                    <h3 className="pricing-card-title">Formule Goûter</h3>

                                    <p className="pricing-card-price">245€</p>

                                    <Box className="pricing-card-features">
                                        <Box className="pricing-feature">
                                            <RestaurantRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text pricing-feature-text--strong">1h dans l'eau + Espace Goûter</p>
                                        </Box>

                                        <Box className="pricing-feature">
                                            <PoolRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">Accès piscine + salle à l’étage incluse</p>
                                        </Box>

                                        <Box className="pricing-feature">
                                            <CelebrationRoundedIcon className="pricing-feature-icon" />
                                            <p className="pricing-feature-text">Jeux, animation, musique &amp; matériel inclus</p>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </section>
            <section className="section-event-snack-room">
                <Container maxWidth="xl">
                    <Box className="event-snack-room">
                        <Grid container spacing={4} alignItems="center">
                            <Grid item xs={12} md={6}>
                                <Box className="event-snack-room-content">
                                    <p className="baseline">OPTION GOÛTER</p>

                                    <h2 className="event-snack-room-title">Prolongez la fête hors de l'eau !</h2>

                                    <p className="event-snack-room-text">
                                        Pour que la fête soit complète, vous pouvez réserver l’étage de la piscine afin d’organiser un moment goûter
                                        après la baignade
                                    </p>

                                    <Box className="event-snack-room-feature">
                                        <Box className="event-snack-room-feature-icon">
                                            <KitchenRoundedIcon />
                                            <p className="">Espace équipé</p>
                                        </Box>

                                        <Box>
                                            <ul>
                                                <li className="event-snack-room-feature-text">
                                                    Un réfrigérateur est mis à votre disposition pour conserver gâteaux et boissons.
                                                </li>
                                                <li className="event-snack-room-feature-text">
                                                    Goûter non fourni : vous êtes libre d’apporter ce que vous souhaitez pour célébrer l’anniversaire.
                                                </li>
                                            </ul>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Box className="event-snack-room-image-card">
                                    <Box
                                        component="img"
                                        src={imgAnniversaireGroupe}
                                        alt="Espace goûter anniversaire"
                                        className="event-snack-room-image"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </section>
            <section className="section-contact">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h2 className="accueil-histoire-titre" data-title="Prêt à réserver ?">
                                    Prêt à réserver ?
                                </h2>
                                <p className="text-center">
                                    Les anniversaires sont organisés <strong>le dimanche après-midi</strong>, sur réservation entre 13h30 et 17h30.
                                </p>
                                <br />
                                <p className="">
                                    Pour connaître les disponibilités ou réserver une date, contactez-nous au{" "}
                                    <strong>
                                        <a href="tel:+33625920851" rel="no-follow no-index" className="phone-contact">
                                            06 25 92 08 51
                                        </a>
                                    </strong>
                                    .
                                </p>
                                <p>
                                    Nous serons ravis de vous aider à organiser un anniversaire aquatique dont les enfants se souviendront longtemps !
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </div>
    );
}
